import { render, staticRenderFns } from "./sga.vue?vue&type=template&id=5dde7a42"
import script from "./sga.vue?vue&type=script&lang=js"
export * from "./sga.vue?vue&type=script&lang=js"
import style0 from "./sga.vue?vue&type=style&index=0&id=5dde7a42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports